/* Colour story, cinematic touches. Everything here stays inside this section.
   - Entrance: the squares arrive one after another as the panel comes into view
   Nothing moves for visitors who have asked for less motion. */
(function () {
  const calm = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const grid = root.querySelector('.triptych__grid');
    const cells = Array.from(root.querySelectorAll('.triptych__cell'));
    if (!grid) return;

    /* Entrance */
    if (!calm() && 'IntersectionObserver' in window) {
      root.classList.add('fx-ready');
      const once = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { root.classList.add('is-in'); once.disconnect(); }
      }, { threshold: 0.35 });
      once.observe(root);
    }

  };

  const run = () => document.querySelectorAll('[data-triptych]').forEach(setup);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  document.addEventListener('shopify:section:load', run);
})();
